import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Banner from '@cont/TalkToUnacademy/Banner';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import useCertificationCourseData from './useCertificationCourseData';

const ttuConfig = {
  imgUrl: 'ttu/ttu_illustration_call.svg',
  title: 'Contact us',
  subTitle:
    'If you have any questions about this course, the university, the certificate or anything else, click the button and get a call from our expert who can answer all your questions.'
};

const Wrapper = styled.div`
  .certificationCoursesTTU {
    box-shadow: none;
    padding: ${Spacings.SPACING_0B};
    margin: ${Spacings.SPACING_0B};

    .ttu-title {
      font-size: ${Fonts.H3};
      line-height: 32px;
    }
    .ttu-description {
      font-size: ${Fonts.P1};
      line-height: ${Spacings.SPACING_5B};
      margin-bottom: ${Spacings.SPACING_6B};
      width: 524px;
    }
    .ttu-illustration-container {
      margin-top: ${Spacings.SPACING_0B};
    }
    button {
      background-color: white;
      border: ${Spacings.SPACING_1} solid var(--color-divider-tertiary);
      width: 215px;
      border-radius: ${Spacings.SPACING_2B};
      color: var(--color-text-primary);
    }
  }
  ${mediaQuery.uptoMobile} {
    .certificationCoursesTTU {
      box-shadow: none;
      margin: ${Spacings.SPACING_0B} !important;
      padding: ${Spacings.SPACING_0B} !important;
      .ttu-left {
        flex: 1;
      }
      .ttu-title {
        font-size: ${Fonts.H4};
        line-height: 26px;
      }
      .ttu-description {
        font-size: ${Fonts.P1};
        line-height: ${Spacings.SPACING_5B};
        margin-bottom: ${Spacings.SPACING_7B};
        width: 242px;
      }
      .ttu-illustration-container {
        width: 70px;
        height: 70px;
        margin: ${Spacings.SPACING_0B};
      }
      .ttu-call {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: ${Spacings.SPACING_18};
      }
      button {
        width: 100%;
      }
    }
  }
`;

const CertificationCoursesTTU = ({
  goalDetails,
  className,
  ttuEventsProps = {},
  goalUID
}) => {
  const { overAll = {} } = useCertificationCourseData(goalUID);
  const config = {
    ...ttuConfig,
    ttuEventsProps,
    title: overAll?.contactUsTitle,
    subTitle: overAll?.contactUsDescription
  };
  return (
    <Wrapper>
      <Banner
        goalDetails={goalDetails}
        ttuConfig={config}
        className={className}
      />
    </Wrapper>
  );
};

export default CertificationCoursesTTU;

CertificationCoursesTTU.propTypes = {
  goalDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string
};

CertificationCoursesTTU.defaultProps = {
  className: 'certificationCoursesTTU'
};
